'use strict';

angular.module('admin')
.controller('ProgrammeAdminCtrl', function ($scope, model, modelNameField, programmes)
{
    $scope.model = model;
    $scope.themes = programmes.themes;

    $scope.modelNameField = modelNameField;

    $scope.selectedBundles = [];

    $scope.saveModel = function ()
    {
        $scope.model.DSCreate(model, {upsert: true}).then($scope.$close);
    };
});
